var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Formik } from 'formik';
import React, { useState } from 'react';
import useListMySalePoints from '../../hooks/useListMySalePoints';
import AddSalePointModal from '../AddSalePointModal';
import conditions from './conditionTypes.json';
import './index.less';
import { createClassified } from '../../utils/api/classifiedApi';
import ClassifiedForm from './ClassifiedForm';
import { validateForm } from './classifiedValidator';
import { captureException } from '../../utils/sentry';
var CreateClassifiedForm = function (props) {
    var onComplete = props.onComplete, bookIsbn = props.bookIsbn;
    var _a = useState(false), showAddSalePoint = _a[0], setShowAddSalePoint = _a[1];
    var _b = useListMySalePoints(), salePoints = _b.salePoints, reFetchSalePoints = _b.reFetch;
    var onSalePointAdded = function () {
        setShowAddSalePoint(false);
        // Reload the sale points
        reFetchSalePoints();
    };
    var notifyClassifiedCreated = function (classified) {
        onComplete(classified);
    };
    var publishClassified = function (values, _a) {
        var setSubmitting = _a.setSubmitting, setStatus = _a.setStatus, setFieldError = _a.setFieldError;
        if (!bookIsbn) {
            setStatus({ apiError: 'Du må velge en bok til annonsen din' });
            setSubmitting(false);
            return;
        }
        createClassified(Object.assign(values, { isbn: bookIsbn }))
            .then(function (data) {
            setSubmitting(false);
            // Clear any dangling api errors
            setStatus({ apiError: null });
            notifyClassifiedCreated(data);
        })
            .catch(function (err) {
            setSubmitting(false);
            // Notify the form of unsuccessful save
            setStatus({ apiError: err.message });
            var errors = err.data && err.data.errors ? err.data.errors : null;
            // Server can give specific errors for specific fields
            if (errors) {
                Object.keys(errors)
                    .forEach(function (key) {
                    setFieldError(key, errors[key]);
                });
            }
            // Capture any critical failures
            if (!err.status || err.status >= 500) {
                captureException(err, null, { isbn: bookIsbn }, { classifiedValues: values });
            }
        });
    };
    return React.createElement("div", null,
        React.createElement(Formik, { initialValues: {
                price: 0,
                condition: conditions[0].value,
                salePoint: '',
                tags: [],
            }, validate: validateForm, onSubmit: publishClassified }, function (formikProps) { return React.createElement(ClassifiedForm, __assign({}, formikProps, { bookIsbn: bookIsbn, salePoints: salePoints, showSalePointModal: function () { return setShowAddSalePoint(true); } })); }),
        showAddSalePoint && React.createElement(AddSalePointModal, { onDismiss: function () { return setShowAddSalePoint(false); }, onComplete: onSalePointAdded }));
};
export default CreateClassifiedForm;
